import type { SortDirection } from "../../Table";

export interface SortParam {
  readonly value: string | undefined;
  readonly directionOf: (key: string) => SortDirection;
  readonly cycle: (key: string) => void;
}

export function parseSort(value: string | undefined): { key: string; descending: boolean } | null {
  if (!value) return null;
  const dot = value.lastIndexOf(".");
  if (dot <= 0) return null;
  const direction = value.slice(dot + 1);
  if (direction !== "asc" && direction !== "desc") return null;
  return { key: value.slice(0, dot), descending: direction === "desc" };
}

export function nextSort(value: string | undefined, key: string): string | undefined {
  const current = parseSort(value);
  if (current?.key !== key) return `${key}.desc`;
  return current.descending ? `${key}.asc` : undefined;
}

export function useSortParam(value: string | undefined, onChange: (next: string | undefined) => void): SortParam {
  return {
    value,
    directionOf: (key) => {
      const current = parseSort(value);
      if (current?.key !== key) return "none";
      return current.descending ? "descending" : "ascending";
    },
    cycle: (key) => {
      onChange(nextSort(value, key));
    },
  };
}
